import { Link, Typography } from "@mui/material";
import { Links } from "src/constants";
import { FeedItemDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const RoleDescriptionPropertyChange = (props: Props) => {
  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated description to </span>
      <strong>{props.feedItem.propertyChange!.value}</strong>
    </Typography>
  );
};

export { RoleDescriptionPropertyChange };
